import createVueComponent from '../createVueComponent';

const ArrowLeftFromLine = createVueComponent('ArrowLeftFromLineIcon', [
  ['path', { d: 'm9 6-6 6 6 6', key: '7v63n9' }],
  ['path', { d: 'M3 12h14', key: '13k4hi' }],
  ['path', { d: 'M21 19V5', key: 'b4bplr' }],
]);

export default ArrowLeftFromLine;
